var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flash_messages text-center"},_vm._l((_vm.messages),function(message,type){return _c('flash-message',{key:message,attrs:{"message":message,"type":type}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }